module.exports = __webpack_public_path__ + "static/media/richikcard.f3dc700f.jpg";